import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Billing() {
  return <Box><Typography variant="h4">Billing</Typography></Box>;
}
